import { IStyle } from '@fluentui/react';

import { IH2OTheme } from '../../models/components.models';
import { FontSizes } from '../../themes/styles';

export interface IEmptyMessageStyles {
  root: IStyle;
  image: IStyle;
  title: IStyle;
  message: IStyle;
  body: IStyle;
  link: IStyle;
}

export const emptyMessageStylesDefault = (theme: IH2OTheme): IEmptyMessageStyles => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    textAlign: 'center',
  },
  body: {},
  image: {
    display: 'inline-block',
    width: 132,
    height: 132,
    borderRadius: '50%',
    lineHeight: 132,
    backgroundColor: theme.palette?.primary100,
    fontSize: 70,
    color: theme.palette?.primary600,
    marginBottom: 20,
  },
  title: { fontSize: FontSizes.xxxlarge, color: theme.semanticColors?.textPrimary, marginBottom: 16 },
  message: { fontSize: FontSizes.large, color: theme.semanticColors?.textSecondary },
  link: {
    marginTop: 8,
  },
});
